module.exports = __webpack_public_path__ + "static/media/logo-text.3e7d64ae.png";